var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExecutionPeriodRadioField',_vm._g({attrs:{"field":"custom-dimension-1","choices":_vm.choices}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }